import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../services/api";
import "../styles/productDetails.css";

export default function ProductDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // main product
        const res = await API.get(`/stock/${id}`);
        setProduct(res.data);

        // related variants
        const relatedRes = await API.get(`/stock/related/${id}`);
        setRelated(relatedRes.data || []);
      } catch (err) {
        console.error("Error loading product details", err);
      }
    };

    fetchData();
  }, [id]);

  if (!product) return <h1>Loading...</h1>;

  return (
    <div className="product-details-page">

      {/* BACK */}
      <button onClick={() => navigate(-1)} className="btn-back">
        ← Back
      </button>

      {/* MAIN PRODUCT */}
      <div className="details-box">
        <h2>{product.name}</h2>

        <div className="details-grid">
          <p><b>Price:</b> ₹{product.price}</p>
          <p><b>Quantity:</b> {product.quantity}</p>
          <p><b>Desk:</b> {product.desk || 0}</p>
          <p><b>Brand:</b> {product.brand || "No Selected"}</p>
          <p><b>Model:</b> {product.model || "No Selected"}</p>
          <p>
            <b>Created:</b>{" "}
            {new Date(product.createdAt).toLocaleString()}
          </p>
        </div>

        <p className="note">
          <b>NOTE:</b> {product.name} product hai jo{" "}
          <b style={{ color: "#22d3ee" }}>
            {product.brand || "unknown brand"}
            {product.model && ` (${product.model})`}
          </b>{" "}
          ke liye hai
        </p>
      </div>


   {/* OTHER VARIANTS */}
<div className="details-box" style={{ marginTop: "30px" }}>
  <h3 style={{ color: "#22d3ee" }}>Other Variants</h3>

  {related.length === 0 ? (
    <p style={{ opacity: 0.7 }}>
      No other variants available for this product.
    </p>
  ) : (
    related.map(item => (
      <div
        key={item._id}
        onClick={() => navigate(`/product/${item._id}`)}
        style={{
          border: "1px solid rgba(255,255,255,0.15)",
          padding: "14px",
          borderRadius: "12px",
          marginTop: "12px",
          cursor: "pointer"
        }}
      >
        <p><b>Brand:</b> {item.brand || "No Selected"}</p>
        <p><b>Model:</b> {item.model || "No Selected"}</p>
        <p><b>Price:</b> ₹{item.price}</p>
        <p><b>Qty:</b> {item.quantity}</p>
        <p><b>Desk:</b> {item.desk || 0}</p>
        <p>
          <b>Date:</b>{" "}
          {new Date(item.createdAt).toLocaleDateString()}
        </p>
      </div>
    ))
  )}
</div>
    </div>
  );
}
